<script setup>
import { defineProps, defineModel, computed } from 'vue';
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
    label: String,
    autocomplete: {
        type: String,
        default: 'off'
    },
    maxlength: {
        type: Number,
        default: 180
    },
    rules: {
        type: Array,
        default: () => []
    },
    readonly: {
        type: Boolean,
        default: false
    },
    required: {
        type: Boolean,
        default: false
    }
});

const model = defineModel();

const maxLengthRule = (v) => (
    (v?.length || 0) <= props.maxlength || t('common.messages.info.enterMaximumCharacters', { count: props.maxlength })
);
const requiredRule = (v) =>
    !!v || t('common.messages.validations.required')

const combinedRules = computed(() => {
    const rules = [...props.rules, maxLengthRule]
    if (props.required) rules.unshift(requiredRule)
    return rules
})

const inputClasses = computed(() => ({
    'field-default': true,
    'input-disabled': props.readonly
}))
</script>

<template>
    <v-textarea
        v-model="model"
        :label="label"
        :autocomplete="autocomplete"
        :counter="props.maxlength"
        :maxlength="props.maxlength"
        :rules="combinedRules"
        :class="inputClasses"
        :readonly="readonly"
    ></v-textarea>
</template>
